export default __webpack_public_path__ + "static/media/6.df74ebc5.gif";